import React, { useContext, useEffect } from 'react'
import studyReportContext from '../../../../../context/studyreport/StudyReportContext';
import ConfirmModal from '../../../../../components/Modal/ConfirmModal';
import { useTranslation } from 'react-i18next';

const AddendumDisclaimerModal = (props) => {

    const { t } = useTranslation();

    const {
        // addendumDisclaimerAddedByRad,
        // setAddendumDisclaimerAddedByRad,
        showAddendumDisclaimerModal,
        setShowAddendumDisclaimerModal,
        showConfirmModal,
        setShowConfirmModal,
        handleSubmitReport,
        // showAddendumDisclaimerPopup,
        setShowAddendumDisclaimerPopup
      } = useContext(studyReportContext);

      const handleConfirmAddendumByRad = () =>{
        // setAddendumDisclaimerAddedByRad(true);
        let addendumDisclaimerAddedByRadVal = true;
        setShowAddendumDisclaimerModal(false);
        setShowConfirmModal(false);
        // setShowAddendumDisclaimerPopup(false);
        let showAddendumDisclaimerPopupVal = false;
        handleSubmitReport(
            true,
            props.keyImages,
            props.annotationData,
            props.annotationDataAI,
            props.allTextToolAnnotation,
            props.activeViewportIndex,
            false,
            addendumDisclaimerAddedByRadVal,
            showAddendumDisclaimerPopupVal
        );
      }

      const handleNotConfirmAddendumByRad = () =>{
        // setAddendumDisclaimerAddedByRad(false);
        let addendumDisclaimerAddedByRadVal = false;
        setShowAddendumDisclaimerModal(false);
        setShowConfirmModal(false);
        // setShowAddendumDisclaimerPopup(false);
        let showAddendumDisclaimerPopupVal = false;
        handleSubmitReport(
            true,
            props.keyImages,
            props.annotationData,
            props.annotationDataAI,
            props.allTextToolAnnotation,
            props.activeViewportIndex,
            false,
            addendumDisclaimerAddedByRadVal,
            showAddendumDisclaimerPopupVal
        );
      }

      const handleCloseConfirmModal = () =>{
        setShowConfirmModal(false);
        setShowAddendumDisclaimerPopup(true);
        return;
      }
    

  return (
    <ConfirmModal handleConfirm={handleConfirmAddendumByRad} handleNotConfirm={handleNotConfirmAddendumByRad} handleCloseIcon={handleCloseConfirmModal} setShowConfirmModal={setShowConfirmModal} showConfirmModal={showConfirmModal} message={t("confirm-message.confirm-addendum-disclaimer-in-report")}
          title={t("confirm-message.confirm")} confirmButtonText={t("confirm-message.yes")} cancelButtonText={t("confirm-message.no")}/>
  )
}

export default AddendumDisclaimerModal